import { FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import * as React from 'react';
import { Unit } from '../Services/Unit/UnitApi';
import { useUnits } from '../Services/Unit/UnitHooks';
import { FieldError } from 'react-hook-form';

interface UnitSelectProps {
    onChange: (selected: Unit) => void;
    onBlur: () => void;
    value: Unit | undefined;
    error: FieldError | undefined;
}

const UnitSelect = React.forwardRef<any, UnitSelectProps>(({ onChange, onBlur, value, error }, ref) => {
    const { data: units } = useUnits();

    const handleSelect = (event: SelectChangeEvent) => {
        const selectedId = event.target.value as string;
        onChange(units?.find(o => o.id === selectedId)!);
    };

    const getMenuItem = (unit: Unit) => {
        return (
            <MenuItem value={unit.id} key={unit.id}>{unit.name}</MenuItem>
        );
    };

    return (
        <>
            {units ? (
                <>
                    <InputLabel id="unit-select-label">{'Select Unit'}</InputLabel>
                    <Select
                        labelId="unit-select-label"
                        label="Select Unit"
                        onChange={handleSelect}
                        value={value?.id ?? ""}
                        inputRef={ref}
                        onBlur={onBlur}
                        error={!!error}
                    >
                        {units.map(getMenuItem)}
                    </Select>
                    <FormHelperText>{error ? error.message : ""}</FormHelperText>
                </>
            ) : (
                <Typography>Loading</Typography>
            )}
        </>
    );
});

export default UnitSelect;